    
<template>
    <div class="dashBox">
        <a-spin :spinning="tloading">
            <div style=" padding: 20px 0;">
                <a-row :gutter="16">
                    <a-col :span="8">
                        <a-card>
                            <a-statistic title="已发送" :value="totalsendct"
                                :value-style="{ color: '#3f8600' }" style="margin-right: 50px">
                                <template #prefix>
                                    <a-icon type="message" />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="8">
                        <a-card>
                            <a-statistic title="已读" :value="totalreadct"  class="demo-class"
                                :value-style="{ color: '#3f8600' }">
                                <template #prefix>
                                    <a-icon type="read" />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                    <a-col :span="8">
                        <a-card>
                            <a-statistic title="已读率" :value="readproportion*100" :precision="2" suffix="%"
                                :value-style="{ color: '#3f8600' }" style="margin-right: 50px">
                                <template #prefix>
                                    <a-icon type="rise" />
                                </template>
                            </a-statistic>
                        </a-card>
                    </a-col>
                </a-row>
            </div>

            <a-empty v-if="sendct_.length == 0" description="暂无数据" style="margin-top:80px;" />
            <div id="wschartID" style="width: 100%;"></div>


            <div style="padding:20px;">
                <a-table :columns="columns" :data-source="tableData" rowKey="classname" :pagination="false">
                </a-table>
            </div>
        </a-spin>
    </div>
</template>

<script>
const columns = [
    {
        title: '类别',
        dataIndex: 'classname',
    },
    {
        title: '总数',
        dataIndex: 'total',
    },
    {
        title: '平均',
        dataIndex: 'avg',
    },
    {
        title: '最高',
        dataIndex: 'max',
    },
    {
        title: '最低',
        dataIndex: 'min',
    },
]
export default {
    data() {
        return {
            chartSys:null,
            chartDate:[1],
            searchP:{
                channelcode:'',
                passwaytype:'',
            },
            sendct_:[],
            readct_:[],
            time_:[],
            tloading:false,

            totalsendct:0,
            totalreadct:0,
            readproportion:0,

            tableData:[],
            columns
        }
    },

    methods: {
        resetData(){
            this.sendct_ = [];
            this.readct_ = [];
            this.time_ = [];
        },
        loadData(searchP){
            if(searchP){
                this.searchP = searchP
            }
            let that = this;
            that.tableData = [];
            that.tloading = true;
            that.resetData();
            let params = {
                channelcode:that.searchP.channelcode,
                messagestypecode:that.searchP.messagestypecode,
                querytype:that.searchP.selectedTimeRange.split('~')[2],
                starttime:that.searchP.selectedTimeRange.split('~')[0],
                endtime:that.searchP.selectedTimeRange.split('~')[1],
            };
            that.$store.dispatch({
                type: "mcmsmanager/queryReadCt",
                params:params
            }).then((res)=>{
                that.tloading = false
                if(res.status == 200 && res.data.success == '1'){
                    let res_data = res.data.data.items;
                    res_data.forEach(element => {
                        that.readct_.push(element.readct);
                        that.sendct_.push(element.sendct);
                        that.time_.push(element.time);
                    });
                    that.totalsendct = res.data.data.totalsendct;
                    that.totalreadct = res.data.data.totalreadct;
                    that.readproportion = res.data.data.readproportion;

                    //组装表格
                    let tempData = res.data.data;
                    that.tableData.push({
                        classname:'已发送',
                        total:tempData.totalsendct,
                        avg:tempData.avgsendct,
                        max:tempData.maxsendct,
                        min:tempData.minsendct,
                    })
                    that.tableData.push({
                        classname:'已读',
                        total:tempData.totalreadct,
                        avg:tempData.avgreadct,
                        max:tempData.maxreadct,
                        min:tempData.minreadct,
                    })

                    that.analystData();
                }
            }).catch(() => {
                that.tloading = false
            });
        },
        //按日期统计数据
        analystData(){
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById("wschartID").style.height = "300px";
            that.chartSys = that.$echarts.init(document.getElementById("wschartID"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
            });
            
        },
        getDatailOption(){
            let option = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    top:'bottom',
                    data: ['已发送', '已读']
                },
                grid: {
                    top: '3%',
                    lett:'3%'
                },

                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.time_
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '已发送',
                        type: 'line',
                        data: this.sendct_
                    },
                    {
                        name: '已读',
                        type: 'line',
                        data: this.readct_
                    },
                ]
            };
            return option;
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },

}
</script>

